(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9055],{

/***/ 8002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ FREE_SECOND_SHIPPING_MIN_AMOUNT; },
/* harmony export */   "Nd": function() { return /* binding */ GOOGLE_RATING; },
/* harmony export */   "fI": function() { return /* binding */ DELIVERY_COST; },
/* harmony export */   "qM": function() { return /* binding */ SECOND_DELIVERY_COST; },
/* harmony export */   "yP": function() { return /* binding */ FREE_SHIPPING_MIN_AMOUNT; }
/* harmony export */ });
var FREE_SHIPPING_MIN_AMOUNT = 35000;
var FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
var DELIVERY_COST = 3490;
var SECOND_DELIVERY_COST = 990;
var GOOGLE_RATING = 4.8;


/***/ }),

/***/ 96657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useScrollTracking; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _validators_Events_Screen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42101);
/* harmony import */ var _useEventTracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66630);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _usePersistState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70473);






var MUTE_SCROLL = true;
function useScrollTracking() {
    var isBrowser = "object" !== "undefined";
    var track = (0,_useEventTracking__WEBPACK_IMPORTED_MODULE_2__/* .useEventTracking */ .A)().track;
    var lastTrackedPercentage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var currentScreenRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var routeKey = "screen_instance_id_".concat(router.pathname);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_usePersistState__WEBPACK_IMPORTED_MODULE_4__/* .usePersistState */ .f)(routeKey, ""), 1), screenInstanceId = ref[0];
    var trackScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(screenType) {
        if (!isBrowser) return;
        currentScreenRef.current = {
            event: screenType.toString(),
            screenInstanceId: screenInstanceId,
            screenType: _validators_Events_Screen__WEBPACK_IMPORTED_MODULE_1__/* .ScreenEventType */ .O[screenType]
        };
    }, [
        isBrowser,
        screenInstanceId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isBrowser) return;
        var timeout;
        var handleScroll = function() {
            if (!currentScreenRef.current) return;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                var scrollHeight = document.body.scrollHeight;
                var scrollPosition = window.scrollY;
                var viewportHeight = window.innerHeight;
                var maxScroll = scrollHeight - viewportHeight;
                var scrollPercentage = scrollPosition / maxScroll * 100;
                var scrollHasChangedEnough = !MUTE_SCROLL && Math.abs(scrollPercentage - lastTrackedPercentage.current) > 5;
                if (scrollHasChangedEnough) {
                    void track(_validators_Events_Screen__WEBPACK_IMPORTED_MODULE_1__/* .ScreenEventType */ .O[currentScreenRef.current.screenType], {
                        screen_instance_id: currentScreenRef.current.screenInstanceId,
                        scroll_percentage: scrollPercentage
                    });
                    lastTrackedPercentage.current = scrollPercentage;
                }
            }, 1000);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(timeout);
            currentScreenRef.current = null;
        };
    }, [
        track,
        isBrowser
    ]);
    return {
        trackScroll: trackScroll
    };
}


/***/ }),

/***/ 61321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LandingMain": function() { return /* binding */ LandingMain; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useModalOpenState.tsx
var useModalOpenState = __webpack_require__(57117);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/screens/home/footer.tsx + 1 modules
var footer = __webpack_require__(63348);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(47028);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(76992);
;// CONCATENATED MODULE: ./src/screens/home/landing/FaqSection/faqSection.styles.tsx



var RootDiv = (0,styled/* default */.Z)("div")({
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "32px 0px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Poppins",
        fontSize: "clamp(24px, 4vw, 56px)",
        lineHeight: "clamp(24px, 4vw, 56px)",
        letterSpacing: "0.15px",
        color: "#1C3D72",
        fontWeight: 500,
        marginBottom: "50px"
    };
});
var QuestionTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        fontWeight: 400,
        color: "#414046"
    }, theme.breakpoints.up(992), {
        fontSize: "18px",
        lineHeight: "27px"
    });
});
var AnswerTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    fontWeight: 300,
    marginBottom: "5px"
});
var AnswerTypographyLink = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    fontWeight: 300,
    color: "#0A7ABE",
    display: "inline",
    cursor: "pointer"
});
var IconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    height: "30px",
    width: "30px"
});
var CustomAccordion = (0,styled/* default */.Z)(Accordion/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "boxOpen";
    }
})(function(param) {
    var boxOpen = param.boxOpen;
    return {
        boxShadow: "none",
        width: "80%",
        maxWidth: "800px",
        marginBottom: "17px",
        transitionDelay: "0.1s",
        textAlign: "left",
        ".MuiAccordionDetails-root": {
            textAlign: "left",
            paddingTop: "25px",
            marginBottom: "17px",
            border: "solid 1px #EAEAEA",
            borderTopWidth: "0px",
            borderEndStartRadius: "10px",
            borderEndEndRadius: "10px",
            transition: "border-radius 0.2s",
            transitionDelay: "0.05s"
        },
        ".MuiAccordionSummary-root": {
            border: "solid 1px #EAEAEA",
            borderBottomWidth: boxOpen ? "0px" : "1px",
            borderStartStartRadius: "10px",
            borderStartEndRadius: "10px",
            borderEndStartRadius: boxOpen ? "0px" : "10px",
            borderEndEndRadius: boxOpen ? "0px" : "10px",
            transition: "border-radius 0.2s",
            transitionDelay: "0.05s"
        },
        "&::before": {
            height: "0px"
        }
    };
});


// EXTERNAL MODULE: ./src/screens/home/components/modalDispatchZones.tsx + 1 modules
var modalDispatchZones = __webpack_require__(90511);
;// CONCATENATED MODULE: ./src/screens/home/landing/FaqSection/FaqSection.tsx











function FaqSection() {
    var router = (0,next_router.useRouter)();
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var handleOpenModal = function() {
        return setIsModalOpen(true);
    };
    var handleCloseModal = function() {
        return setIsModalOpen(false);
    };
    var QUESTIONS = (0,react.useMemo)(function() {
        return [
            {
                question: "\xbfPuedo comprar con receta simple o retenida?",
                answer: "S\xed, puedes comprar medicamentos con receta simple o retenida. Para esto deber\xe1s subir una foto de la receta y, luego de que hagas la compra, la foto ser\xe1 revisada por uno de nuestros qu\xedmicos farmac\xe9uticos. En caso de ser necesario, coordinaremos el retiro de la receta al momento de la entrega."
            },
            {
                question: "\xbfA qu\xe9 comunas despachan?",
                answer: "Actualmente despachamos en la Provincia de Santiago y algunos sectores de Colina, San Bernardo, Puente Alto y Lampa.",
                subAnswer: "Conoce nuestra ",
                subAnswerLink: "zona de despacho",
                subAnswer2: "Si est\xe1s fuera de la zona de despacho, puedes realizar tu pedido seleccionando la opci\xf3n de retiro en tienda.",
                modalOpen: handleOpenModal
            },
            {
                question: "\xbfQu\xe9 alternativas de pago tengo?",
                answer: "Puedes pagar con tarjetas de d\xe9bito y cr\xe9dito, y tambi\xe9n con transferencia bancaria."
            },
            {
                question: "\xbfPuedo devolver un medicamento?",
                answer: "S\xed, tienes 10 d\xedas para devolver un medicamento si te equivocaste o arrepentiste de comprarlo. No podr\xe1s devolver productos abiertos, en mal estado, productos con receta retenida o que necesiten refrigeraci\xf3n."
            }, 
        ];
    }, []);
    var ref1 = (0,react.useState)({}), open = ref1[0], setOpen = ref1[1];
    var handleClick = function(index) {
        setOpen((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, open), (0,_define_property/* default */.Z)({}, index, !open[index])));
        if (!open[index]) {
            // only track when question is opened (not closed)
            void track("faq answers view", {
                question: QUESTIONS[Number(index)].question
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modalDispatchZones/* ModalDispatchZones */.$, {
                isModalOpen: isModalOpen,
                handleCloseModal: handleCloseModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                children: " Preguntas frecuentes "
            }),
            QUESTIONS.map(function(question, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomAccordion, {
                    boxOpen: open[index],
                    onClick: function() {
                        return handleClick(index.toString());
                    },
                    disableGutters: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionTypography, {
                                children: question.question
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerTypography, {
                                    children: [
                                        " ",
                                        question.answer,
                                        " "
                                    ]
                                }),
                                question.subAnswer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerTypography, {
                                            children: [
                                                question.subAnswer,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnswerTypographyLink, {
                                                    onClick: function() {
                                                        return question.modalOpen();
                                                    },
                                                    children: [
                                                        question.subAnswerLink,
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AnswerTypography, {
                                            children: question.subAnswer2
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, index);
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/screens/home/landing/cenabastSection/cenabastSection.style.tsx



var cenabastSection_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        padding: "88px 64px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 48
    }, theme.breakpoints.down("md"), {
        padding: "56px 32px",
        gap: 16
    });
});
var Title = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "clamp(24px, 4vw, 40px)",
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "center",
        lineHeight: "150%"
    };
});
var SubtitleContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 48,
        padding: "0px 10%"
    }, theme.breakpoints.down("md"), {
        padding: "0px 10px",
        flexDirection: "column-reverse",
        gap: 16
    });
});
var Subtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 32,
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        lineHeight: "60px"
    }, theme.breakpoints.down("md"), {
        fontSize: 20,
        lineHeight: "36px",
        textAlign: "center"
    });
});


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
;// CONCATENATED MODULE: ./src/screens/home/landing/cenabastSection/cenabastSection.tsx






var CENABAST_IMAGE = "/assets/images/newLanding/Cenabast.webp";
var CenabastSection = function() {
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var imageSize = isDesktop ? 300 : 150;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(cenabastSection_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "REMEDIOS M\xc1S BARATOS Y DE CALIDAD"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: CENABAST_IMAGE,
                        alt: "Cenabast",
                        width: imageSize,
                        height: imageSize
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Subtitle, {
                        children: [
                            "Tenemos cientos de productos Cenabast, rev\xedsalos",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,utils/* getRoute */.Bv)("subCategory", {
                                    categorySlug: "medicamentos",
                                    subCategorySlug: "cenabast"
                                }).toString(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "aria-label": "Revisar productos Cenabast",
                                    children: "aqu\xed"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(83071);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowBack.js
var ArrowBack = __webpack_require__(94669);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowForward.js
var ArrowForward = __webpack_require__(77331);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
;// CONCATENATED MODULE: ./src/screens/home/landing/commentsSection/commentsSection.style.tsx



var commentsSection_style_RootDiv = (0,styled/* default */.Z)("div")(function() {
    return {
        height: "auto",
        padding: "64px 0px"
    };
});
var CommentsContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "relative",
        left: 0,
        padding: "64px 0px"
    }, theme.breakpoints.down("md"), {
        padding: "8px 0px"
    });
});
var TitleContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column",
        gap: 42
    };
});
var commentsSection_style_Title = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "clamp(20px, 4vw, 32px)",
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "center"
    };
});
var RatingContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 24
    };
});
var RatingText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 56,
        fontWeight: 600,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "center"
    }, theme.breakpoints.down("md"), {
        fontSize: 32
    });
});
var ScrollContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
        justifyContent: "center"
    };
});
var ScrollButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function(param) {
    var direction = param.direction, theme = param.theme;
    return {
        backgroundColor: theme.palette.primary.light,
        color: "#ffffff",
        position: "absolute",
        zIndex: 2,
        "&:hover": {
            backgroundColor: "#E0E0E0"
        },
        right: direction === "right" ? 80 : "auto",
        left: direction === "left" ? 80 : "auto"
    };
});
var CommentsCardContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        gap: 12,
        marginTop: 48,
        position: "relative",
        left: 0,
        right: 0,
        overflowX: "auto",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        padding: "16px 44px"
    };
});
var CommentCard = (0,styled/* default */.Z)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        backgroundColor: "white",
        width: 400,
        height: 260,
        borderRadius: 24,
        padding: 24,
        flex: "0 0 auto",
        display: "flex",
        flexDirection: "column",
        gap: 16
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        width: 294,
        height: 324
    }), (0,_define_property/* default */.Z)(_obj, "boxShadow", "0px 4px 16px rgba(0, 0, 0, 0.1)"), _obj;
});
var CommentCardHeader = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        gap: 24,
        alignItems: "center"
    };
});
var CommentCardTitleHeader = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left"
    };
});
var CommentCardComment = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Poppins",
        color: "#414046",
        textAlign: "left",
        lineHeight: "21px",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        WebkitLineClamp: 5
    };
});
var CommentCardRating = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        gap: 24,
        alignItems: "flex-end",
        position: "absolute",
        bottom: 24
    };
});


;// CONCATENATED MODULE: ./src/screens/home/landing/commentsSection/config/constants.tsx
var COMMENTS = [
    {
        name: "Paola y Augusto",
        photo: "/assets/images/newLanding/CommentsGoogle/paola.y.augusto.webp",
        comment: "Fant\xe1stica atenci\xf3n. Muy amables y dispuestos a aclarar todas las dudas. Precios muy convenientes. Les escrib\xed despu\xe9s de haber hecho la compra, para modificar la direcci\xf3n de env\xedo y el destinatario, y result\xf3 todo perfecto. Gran profesionalismo y calidez en la atenci\xf3n. Llaman por tel\xe9fono y env\xedan correo con fotograf\xeda del momento de la entrega. Andrea v\xeda Whatsapp, resuelve todo. Felicitaciones."
    },
    {
        name: "Andrea Basagoitia",
        photo: "/assets/images/newLanding/CommentsGoogle/andrea.basagoitia.webp",
        comment: "Excelente Servicio. Me lleg\xf3 todo lo que ped\xed (hasta un medicamento con receta retenida) un d\xeda antes de la fecha de despacho original. Me avisaron por WhatsApp y me avisaron al llegar. Lo recomiendo 100%"
    },
    {
        name: "Ximena Yentzen-Hutchison",
        photo: "/assets/images/newLanding/CommentsGoogle/ximena.yentzen.webp",
        comment: "Excelente!! He comprado varias veces ya y, no s\xf3lo tienen precios m\xe1s convenientes, sino que la atenci\xf3n y el seguimiento de mi compra es totalmente personal. Por lo menos as\xed lo siento. \uD83D\uDE0A\uD83D\uDC4D\uD83C\uDFFC"
    },
    {
        name: "Mar\xeda Eugenia Meza",
        photo: "/assets/images/newLanding/CommentsGoogle/maria.eugenia.meza.webp",
        comment: "Es una excelente farmacia. Tiene las tres BBB. Encantadora la Andrea que responde el ws. Solucionan todo y llegan m\xe1s que a tiempo. Muy agradecidas de su atenci\xf3n."
    },
    {
        name: "Angela Silva",
        photo: "/assets/images/newLanding/CommentsGoogle/angela.silva.webp",
        comment: "Excelente!!! Rapidez, variedad y precios. Y mucha amabilidad, de todos desde venta y despacho"
    },
    {
        name: "Felipe Merino",
        photo: "/assets/images/newLanding/CommentsGoogle/felipe.merino.webp",
        comment: "Siempre tienen lo que necesito a muy buen precio. Comodidad a la hora de pagar, muy bien organizada la p\xe1gina. F\xe1cil de navegar y sobre todo no te vacunan con el precio como lo hacen las farmacias regulares. 100% recomendado."
    },
    {
        name: "English Teacher",
        photo: "/assets/images/newLanding/CommentsGoogle/english.teacher.webp",
        comment: "Me lleg\xf3 todo lo que compr\xe9 el d\xeda y hora se\xf1aladas sin ning\xfan problema. Muy buena atenci\xf3n. Recomiendo al 100%"
    },
    {
        name: "Luz Azul",
        photo: "/assets/images/newLanding/CommentsGoogle/luz.azul.webp",
        comment: "Compr\xe9 y me lleg\xf3 en perfecto estado a mi casa, inclusive un d\xeda antes. Muy satisfecha con el proceso de compra y el precio fue muy conveniente. Gracias"
    },
    {
        name: "Katerine Hrdalo",
        photo: "/assets/images/newLanding/CommentsGoogle/katherine.hrdalo.webp",
        comment: "Lo mejor Meki. Lo descubr\xed y compr\xe9 mi medicamento mucho m\xe1s barato que en las dem\xe1s farmacias!"
    },
    {
        name: "Mar\xeda Ines Herrera",
        photo: "/assets/images/newLanding/CommentsGoogle/maria.ines.herrera.webp",
        comment: "Tienen todo lo que se requiere y a unos precios extraordinariamente bajos… adem\xe1s cuenta con todas las facilidades para comprar por internet y entrega super r\xe1pida!!!"
    },
    {
        name: "Vivian Liddle",
        photo: "/assets/images/newLanding/CommentsGoogle/vivian.liddle.webp",
        comment: "Antes gastaba una barbaridad mensual en farmacia. Ahora gasto much\xedsimo menos! Excelente servicio!"
    },
    {
        name: "Ana Maria Cavin",
        photo: "/assets/images/newLanding/CommentsGoogle/ana.maria.cavin.webp",
        comment: "Muy confiables, llegan siempre a tiempo, cumplen, est\xe1n en contacto conmigo que es muy bueno.. siempre tengo respuesta"
    },
    {
        name: "Paula Bouchon",
        photo: "/assets/images/newLanding/CommentsGoogle/paula.bouchon.webp",
        comment: "Me encanta Meki \uD83E\uDD29 Tengo todos los remedios en la fecha que los necesito y mucho m\xe1s barato que en cualquier farmacia y adem\xe1s sin salir de mi casa"
    },
    {
        name: "Francisca Lyon",
        photo: "/assets/images/newLanding/CommentsGoogle/francisca.lyon.webp",
        comment: "Lo que m\xe1s me gusta es que me recuerden cu\xe1ndo debo hacer la pr\xf3xima compra \uD83D\uDDD3️, los precios y el profesionalismo"
    },
    {
        name: "Rafael Vald\xe9s",
        photo: "/assets/images/newLanding/CommentsGoogle/rafael.valdes.webp",
        comment: "Muchas gracias. Excelente servicio \uD83D\uDC4C\uD83C\uDFFB Cualquier producto que necesite les comprar\xe9 "
    },
    {
        name: "Sylvia Alarc\xf3n",
        photo: "/assets/images/newLanding/CommentsGoogle/sylvia.alarcon.webp",
        comment: "Lo mejor es que cuentan con medicamentos muy dif\xedciles de encontrar en otras partes \uD83D\uDD0D"
    }, 
];

// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
;// CONCATENATED MODULE: ./src/screens/home/landing/commentsSection/commentsSection.tsx









var CommentsSection = function() {
    var scrollRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showLeft = ref[0], setShowLeft = ref[1];
    var ref1 = (0,react.useState)(true), showRight = ref1[0], setShowRight = ref1[1];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var checkScrollPosition = function() {
        if (scrollRef.current) {
            var _current = scrollRef.current, scrollLeft = _current.scrollLeft, scrollWidth = _current.scrollWidth, clientWidth = _current.clientWidth;
            setShowLeft(scrollLeft > 0);
            setShowRight(scrollLeft + clientWidth < scrollWidth);
        }
    };
    var scroll = function(direction) {
        if (scrollRef.current) {
            var scrollAmount = 400;
            if (direction === "left") {
                scrollRef.current.scrollBy({
                    left: -scrollAmount,
                    behavior: "smooth"
                });
            } else {
                scrollRef.current.scrollBy({
                    left: scrollAmount,
                    behavior: "smooth"
                });
            }
        }
    };
    (0,react.useEffect)(function() {
        checkScrollPosition();
        var handleScroll = function() {
            return checkScrollPosition();
        };
        var container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(commentsSection_style_RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentsContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(commentsSection_style_Title, {
                            children: "\xbfQU\xc9 DICEN NUESTROS CLIENTES?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/assets/images/newLanding/googleIcon.webp",
                                    alt: "Google Rating",
                                    width: 32,
                                    height: 32,
                                    layout: "intrinsic",
                                    sizes: "32px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingText, {
                                    children: constants/* GOOGLE_RATING */.Nd
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    defaultValue: 5,
                                    readOnly: true,
                                    size: "large"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollContainer, {
                    children: [
                        showLeft && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButton, {
                            onClick: function() {
                                return scroll("left");
                            },
                            direction: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsCardContainer, {
                            ref: scrollRef,
                            children: COMMENTS.map(function(comment) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentCardHeader, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: comment.photo,
                                                    alt: comment.name,
                                                    width: 48,
                                                    height: 48
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCardTitleHeader, {
                                                    children: comment.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCardComment, {
                                            children: '"'.concat(comment.comment, '"')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCardRating, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                defaultValue: 5,
                                                readOnly: true,
                                                size: "large"
                                            })
                                        })
                                    ]
                                }, comment.name);
                            })
                        }),
                        showRight && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollButton, {
                            onClick: function() {
                                return scroll("right");
                            },
                            direction: "right",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
;// CONCATENATED MODULE: ./src/screens/home/landing/compareAndCheckSection/compareAndCheck.style.tsx



var compareAndCheck_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        background: "linear-gradient(to right, #FFFFFF 5%, #A8CFFF 100%)",
        padding: "88px 64px",
        justifyContent: "space-between",
        display: "flex",
        flexDirection: "row"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        padding: "32px 16px",
        flexDirection: "column"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xl"), {
        padding: "88px 200px"
    }), _obj;
});
var compareAndCheck_style_TitleContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyContent: "center"
    };
});
var compareAndCheck_style_Title = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: "clamp(20px, 4vw, 32px)",
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "left",
        marginBottom: 80
    }, theme.breakpoints.down("md"), {
        textAlign: "center",
        marginBottom: 10
    });
});
var compareAndCheck_style_Subtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: "clamp(24px, 4vw, 56px)",
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left",
        marginBottom: "5vh",
        lineHeight: "150%"
    }, theme.breakpoints.down("md"), {
        textAlign: "center",
        marginBottom: 10
    });
});
var Description = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "center",
        marginBottom: 40
    };
});
var OptionContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 16,
        marginBottom: 24
    };
});
var OptionText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: 32,
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left"
    };
});
var SearchMedicineButton = (0,styled/* default */.Z)(Button/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#0A7ABE",
        color: "white",
        padding: "8px 24px",
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Poppins",
        borderRadius: 100,
        position: "relative",
        "&:hover": {
            backgroundColor: "#0A7ABE"
        },
        height: 58,
        textTransform: "none",
        alignSelf: "flex-start",
        marginTop: 64
    }, theme.breakpoints.down("md"), {
        height: 42,
        marginTop: 32,
        alignSelf: "center"
    });
});
var CompareImagesContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    };
});


// EXTERNAL MODULE: ./src/hooks/useFocusSearchBox.tsx
var useFocusSearchBox = __webpack_require__(31515);
;// CONCATENATED MODULE: ./src/screens/home/landing/compareAndCheckSection/compareAndCheckSection.tsx






var OPTIONS = [
    {
        title: "Precios m\xe1s bajos",
        image: "/assets/images/newLanding/SeccionComparaComprueba/PreciosBajos.svg"
    },
    {
        title: "Mas alternativas",
        image: "/assets/images/newLanding/SeccionComparaComprueba/MasAlternativas.svg"
    }, 
];
var CompareAndCheckSection = function() {
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var router = (0,next_router.useRouter)();
    var focusSearchBox = (0,useFocusSearchBox/* useFocusSearchBox */.G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(compareAndCheck_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(compareAndCheck_style_TitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(compareAndCheck_style_Title, {
                        children: "BUSCA TUS MEDICAMENTOS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(compareAndCheck_style_Subtitle, {
                        children: "Compara y comprueba"
                    }),
                    !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: "Precios m\xe1s bajos \xb7 M\xe1s alternativas"
                    }) : OPTIONS.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: option.image,
                                    alt: "Mas alternativas",
                                    width: 40,
                                    height: 40
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionText, {
                                    children: option.title
                                })
                            ]
                        }, option.title);
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchMedicineButton, {
                        onClick: function() {
                            focusSearchBox.onfocus();
                        },
                        children: "Buscar mis medicamentos"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareImagesContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/images/newLanding/SeccionComparaComprueba/MockupTelefono.webp",
                    alt: "Compare",
                    width: 521,
                    height: 717
                })
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchMedicineButton, {
                onClick: function() {
                    focusSearchBox.onfocus();
                },
                children: "Buscar mis medicamentos"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/home/landing/dispatchSection/dispatchSection.style.tsx



var dispatchSection_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundImage: "url(/assets/images/newLanding/MapaDespacho.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "60vh"
    }, theme.breakpoints.down("md"), {
        backgroundPosition: "center",
        backgroundImage: "url(/assets/images/newLanding/MobMapaDespacho.webp)"
    });
});
var DispatchTitleContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "relative",
        top: 88,
        left: 0,
        padding: "64px 96px",
        zIndex: 100,
        gap: 52,
        display: "flex",
        flexDirection: "column"
    }, theme.breakpoints.down("md"), {
        padding: "32px 48px",
        gap: 16
    });
});
var DispatchTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: "clamp(20px, 4vw, 32px)",
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "left",
        lineHeight: "150%"
    }, theme.breakpoints.down("md"), {
        textAlign: "center"
    });
});
var DispatchSubtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: "clamp(24px, 4vw, 56px)",
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left",
        lineHeight: "150%"
    }, theme.breakpoints.down("md"), {
        textAlign: "center"
    });
});
var DispatchDescription = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 24,
        fontWeight: 400,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left"
    }, theme.breakpoints.down("md"), {
        fontSize: 14,
        textAlign: "center"
    });
});


// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/home/landing/dispatchSection/dispatchSection.tsx





var DispatchSection = function() {
    var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dispatchSection_style_RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DispatchTitleContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DispatchTitle, {
                    children: [
                        "DESPACHO GRATIS SOBRE ",
                        currFormat.format(constants/* FREE_SHIPPING_MIN_AMOUNT */.yP)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchSubtitle, {
                    children: "Entregamos en 36 comunas de la RM"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DispatchDescription, {
                    children: [
                        "Costo de despacho ",
                        currFormat.format(constants/* DELIVERY_COST */.fI),
                        " para compras bajo",
                        " ",
                        currFormat.format(constants/* FREE_SHIPPING_MIN_AMOUNT */.yP)
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/screens/home/components/homeNavBar.tsx + 1 modules
var homeNavBar = __webpack_require__(88617);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
;// CONCATENATED MODULE: ./src/screens/home/landing/styles.tsx


var HeaderContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        position: "sticky",
        top: 0,
        zIndex: 1000
    };
});
var DispatchBannerSection = (0,styled/* default */.Z)("div")(function() {
    return {
        position: "relative",
        background: "#B9D4FF",
        height: "40px",
        width: "100%",
        marginTop: "-1px",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        gap: "8px"
    };
});
var DispatchBannerText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        color: "#15365F",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "24px",
        fontFamily: "Poppins"
    };
});
var DispatchBannerLink = (0,styled/* default */.Z)(Link/* default */.Z)(function() {
    return {
        color: "#15365F",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "24px",
        fontFamily: "Poppins",
        cursor: "pointer"
    };
});
var BodyContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        backgroundColor: "transparent",
        height: "100%",
        position: "relative"
    };
});


;// CONCATENATED MODULE: ./src/screens/home/landing/dispatchBanner.tsx








var DispatchBanner = function() {
    var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width >= 1024;
    var handleOpenModal = function() {
        return setIsModalOpen(true);
    };
    var handleCloseModal = function() {
        return setIsModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DispatchBannerSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DispatchBannerText, {
                children: [
                    "Despacho gratis sobre ",
                    currFormat.format(constants/* FREE_SHIPPING_MIN_AMOUNT */.yP)
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modalDispatchZones/* ModalDispatchZones */.$, {
                        isModalOpen: isModalOpen,
                        handleCloseModal: handleCloseModal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchBannerLink, {
                        onClick: handleOpenModal,
                        children: "Ver zonas de despacho"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.tsx + 1 modules
var referralBannerDiscount = __webpack_require__(30396);
;// CONCATENATED MODULE: ./src/screens/home/landing/header.tsx






var Header = function(props) {
    var isVisible = props.isVisible, setIsVisible = props.setIsVisible, referralUser = props.referralUser;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setIsBannerVisible = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(homeNavBar/* HomeNavBar */.y, {
                isVisible: !isVisible,
                setIsVisible: setIsVisible
            }),
            (referralUser === null || referralUser === void 0 ? void 0 : referralUser.isValid) && isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(referralBannerDiscount/* ReferralBannerDiscount */.N, {
                referenceCouponValidation: referralUser,
                setIsBannerVisible: setIsBannerVisible,
                isBannerVisible: isBannerVisible
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchBanner, {})
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/heroSection.style.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from, to { border-color: transparent; }\n  50% { border-color: var(--caret-color); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var heroSection_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        background: "#white"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        background: "#004C8C",
        padding: "16px 0px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        minHeight: "100vh"
    }), (0,_define_property/* default */.Z)(_obj, "position", "relative"), _obj;
});
var HeroSectionBackground = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "absolute",
        background: "#004C8C",
        width: "100%",
        top: 0,
        clipPath: "polygon(0% 90%, 80% 0%, 100% 0%, 100% 100%, 0% 100%)",
        zIndex: 1,
        height: "100%"
    }, theme.breakpoints.up("md"), {
        minHeight: "100vh"
    });
});
var blinkCaret = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject());
var HeroSectionSubtitleContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        zIndex: 2,
        marginLeft: "clamp(10px, 5%, 120px)",
        marginRight: "auto",
        animation: "\n             ".concat(blinkCaret, " 1s steps(1) infinite;"),
        borderRight: "2px solid var(--caret-color)",
        "--caret-color": "#004C8C"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        marginLeft: "clamp(10px, 5%, 20px)"
    }), (0,_define_property/* default */.Z)(_obj, "width", "auto"), (0,_define_property/* default */.Z)(_obj, "height", "clamp(38px, 6vw, 72px)"), _obj;
});
var HeroSectionSubtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontWeight: "600",
        fontFamily: "Poppins",
        fontSize: "clamp(38px, 6vw, 72px)",
        lineHeight: "100%",
        color: "#004C8C",
        cursor: "default",
        whiteSpace: "nowrap",
        overflow: "hidden",
        paddingBottom: "clamp(10px, 5%, 8px)"
    }, theme.breakpoints.down("md"), {
        color: theme.palette.info.light,
        "--caret-color": "white"
    });
});
var HeroSectionTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "relative",
        zIndex: 2,
        marginLeft: "clamp(10px, 5%, 120px)",
        paddingTop: "clamp(10px, 5%, 60px)",
        width: "auto",
        marginRight: "clamp(6px, 5%, 14px)",
        marginBottom: "clamp(10px, 5%, 20px)",
        fontFamily: "Poppins",
        fontSize: "clamp(38px, 6vw, 72px)",
        lineHeight: "100%",
        fontWeight: "600",
        color: "#004C8C",
        cursor: "default"
    }, theme.breakpoints.down("md"), {
        color: "white"
    });
});
var heroSection_style_RatingText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontWeight: "600",
        fontFamily: "Poppins",
        fontSize: "clamp(14px, 4vw, 24px)",
        lineHeight: "100%",
        color: "white",
        cursor: "default"
    };
});
var RankingContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        position: "relative",
        gap: "2vh"
    };
});
var ImageGoogle = (0,styled/* default */.Z)((image_default()))(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        width: "100%",
        height: "auto",
        maxWidth: 32
    }, theme.breakpoints.down("md"), {
        maxWidth: 24
    });
});
var PillsContainerImage = (0,styled/* default */.Z)("div")(function() {
    return {
        position: "absolute",
        right: "clamp(20px, 4vw, 30px)",
        top: "clamp(20px, 4vw, 64px)",
        zIndex: 1
    };
});
var HeroBodyContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        flexDirection: "column",
        gap: "10vh",
        margin: "10vh 0px"
    }, theme.breakpoints.down("md"), {
        gap: "8vh"
    });
});


// EXTERNAL MODULE: ./src/screens/home/landing/HeroSection/categoriesCard.tsx + 1 modules
var categoriesCard = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./src/components/searchBox.tsx + 8 modules
var searchBox = __webpack_require__(14703);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/useTypewriterEffect.tsx

var useTypewriterEffect = function(phrase, setNextPhrase) {
    var typingSpeed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 80, deleteSpeed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 40, delay = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2000, nextPhraseDelay = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1000;
    var ref = (0,react.useState)(""), currentText = ref[0], setCurrentText = ref[1];
    var ref1 = (0,react.useState)(false), isDeleting = ref1[0], setIsDeleting = ref1[1];
    (0,react.useEffect)(function() {
        var timeout;
        if (!isDeleting && currentText.length < phrase.length) {
            timeout = setTimeout(function() {
                setCurrentText(phrase.slice(0, currentText.length + 1));
            }, typingSpeed);
        } else if (isDeleting && currentText.length > 0) {
            timeout = setTimeout(function() {
                setCurrentText(currentText.slice(0, -1));
            }, deleteSpeed);
        } else if (currentText.length === phrase.length) {
            timeout = setTimeout(function() {
                setIsDeleting(true);
            }, delay);
        } else if (currentText.length === 0) {
            timeout = setTimeout(function() {
                setIsDeleting(false);
                setNextPhrase();
            }, nextPhraseDelay);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        currentText,
        isDeleting,
        phrase,
        typingSpeed,
        deleteSpeed,
        delay,
        nextPhraseDelay, 
    ]);
    return currentText;
};

;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/heroSection.tsx












var phrases = [
    "mejores precios",
    "m\xe1s variedad",
    "mejor servicio"
];
var PHRASE_DELAY = 4000;
var CLIENTS_TEXT = "+25.000 clientes";
var HeroSection = function(props) {
    var theme = (0,useTheme/* default */.Z)();
    var searchRef = props.searchRef, isVisible = props.isVisible, setIsVisible = props.setIsVisible;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    var focusSearchBox = (0,useFocusSearchBox/* useFocusSearchBox */.G)();
    var size = (0,useWindowSize/* useWindowSize */.i)();
    var isMobile = size.width < 1024;
    var isHeader = false;
    (0,react.useEffect)(function() {
        if (focusSearchBox.isFocus && isMobile) {
            setIsVisible(false);
        }
    }, [
        focusSearchBox.isFocus
    ]);
    var getHighlightedPhrase = function(phrase) {
        var typedText = useTypewriterEffect(phrase, function() {
            return setIndex(function(prev) {
                return (prev + 1) % phrases.length;
            });
        });
        var words = typedText.split(" ");
        var lastWord = words.pop();
        var isLastPhrase = typedText.split(" ").length === phrase.split(" ").length;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                words.join(" "),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: isMobile ? theme.palette.info.light : theme.palette.info.main
                    },
                    children: lastWord
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(heroSection_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSectionTitle, {
                children: "La farmacia con "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSectionSubtitleContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSectionSubtitle, {
                    children: getHighlightedPhrase(phrases[index])
                }, index)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSectionBackground, {}),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PillsContainerImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/images/newLanding/PastillasHero.svg",
                    alt: "Pastillas",
                    height: 305,
                    width: 440
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBodyContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(searchBox/* SearchBox */.R, {
                        isHeader: isHeader,
                        isVisible: isVisible,
                        setIsVisible: setIsVisible,
                        searchRef: searchRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(categoriesCard/* CategoriesCard */.g, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankingContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGoogle, {
                                src: "/assets/images/newLanding/googleIcon.webp",
                                alt: "Google Rating",
                                width: 32,
                                height: 32,
                                layout: "intrinsic",
                                sizes: "32px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(heroSection_style_RatingText, {
                                children: constants/* GOOGLE_RATING */.Nd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                defaultValue: 5,
                                readOnly: true,
                                size: isMobile ? "small" : "large"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(heroSection_style_RatingText, {
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(heroSection_style_RatingText, {
                                children: CLIENTS_TEXT
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/screens/home/landing/insuranceSection/insuranceSection.style.tsx


function insuranceSection_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translateX(50%);\n  }\n  to {\n    transform: translateX(-250%);\n  }\n"
    ]);
    insuranceSection_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var scrollAnimation = (0,emotion_react_browser_esm/* keyframes */.F4)(insuranceSection_style_templateObject());
var insuranceSection_style_RootDiv = (0,styled/* default */.Z)("div")(function() {
    return {
        backgroundColor: "#E6F3FF",
        height: "auto",
        padding: "64px 4px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        paddingRight: 0,
        paddingBottom: 32
    };
});
var InsuranceTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 32,
        fontWeight: 600,
        color: theme.palette.info.main,
        textAlign: "center"
    }, theme.breakpoints.down("md"), {
        fontSize: 24
    });
});
var InsuranceSubtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 56,
        fontWeight: 500,
        color: "#1C3D72",
        textAlign: "center",
        lineHeight: "normal"
    }, theme.breakpoints.down("md"), {
        fontSize: 24
    });
});
var InsuranceImagesContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        position: "relative",
        justifyContent: "center",
        left: 0,
        right: 0,
        flexDirection: "row",
        gap: 8,
        overflowX: "auto",
        padding: "4px 64px",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        }
    }, theme.breakpoints.down("md"), {
        padding: "0px 16px",
        justifyContent: "center",
        flexWrap: "wrap"
    });
});
var ScrollingWrapper = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        animation: "".concat(scrollAnimation, " 10s linear infinite"),
        alignItems: "left"
    };
});
var InsuranceImage = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        flex: "0 0 auto"
    };
});


;// CONCATENATED MODULE: ./src/screens/home/landing/insuranceSection/insuranceSection.tsx





var INSURANCE_TITLE = "PAGA CON TU SEGURO";
var INSURANCE_SUBTITLE = "Compra con reembolso autom\xe1tico";
var INSURANCE_IMAGES = [
    "/assets/images/newLanding/insuranceIcon/Zurich.webp",
    "/assets/images/newLanding/insuranceIcon/Sura.webp",
    "/assets/images/newLanding/insuranceIcon/Vid.Security.webp",
    "/assets/images/newLanding/insuranceIcon/BiceVida.webp",
    "/assets/images/newLanding/insuranceIcon/Bci.webp",
    "/assets/images/newLanding/insuranceIcon/VidaCamara.webp",
    "/assets/images/newLanding/insuranceIcon/Help.webp", 
];
var InsuranceSection = function() {
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(insuranceSection_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceTitle, {
                children: INSURANCE_TITLE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSubtitle, {
                children: INSURANCE_SUBTITLE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceImagesContainer, {
                children: (0,_to_consumable_array/* default */.Z)(INSURANCE_IMAGES).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            alt: "insurance",
                            width: isDesktop ? 150 : 120,
                            height: isDesktop ? 150 : 120
                        })
                    }, index);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(35014);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(91359);
;// CONCATENATED MODULE: ./src/screens/home/landing/newsSection/newsSection.style.tsx



var newsSection_style_RootDiv = (0,styled/* default */.Z)("div")(function() {
    return {
        padding: "88px 0px",
        backgroundColor: "#004C8C",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 48,
        position: "relative"
    };
});
var newsSection_style_Title = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#FFFFFF",
        textAlign: "center",
        fontSize: "clamp(34px, 6vw, 56px)"
    };
});
var newsSection_style_ScrollContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
        justifyContent: "center"
    };
});
var newsSection_style_ScrollButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function(param) {
    var direction = param.direction;
    return {
        backgroundColor: "#FFFFFF",
        color: "#004C8C",
        position: "absolute",
        zIndex: 2,
        "&:hover": {
            backgroundColor: "#eaeaea"
        },
        right: direction === "right" ? 100 : "auto",
        left: direction === "left" ? 100 : "auto"
    };
});
var CardsContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        position: "relative",
        justifyContent: "left",
        left: 0,
        right: 0,
        flexDirection: "row",
        gap: 32,
        overflowX: "auto",
        maxWidth: "100vw",
        padding: "4px 64px",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        }
    }, theme.breakpoints.down("md"), {
        padding: "4px 16px"
    });
});
var CardContainer = (0,styled/* default */.Z)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        width: 400,
        height: 400,
        borderRadius: "24px",
        flex: "0 0 auto"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        width: 294,
        height: 342
    }), (0,_define_property/* default */.Z)(_obj, "cursor", "pointer"), _obj;
});
var TitleCard = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: 16,
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "left",
        marginBottom: 8
    };
});
var DescriptionCard = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 16,
        fontWeight: 400,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "left"
    }, theme.breakpoints.down("md"), {
        fontSize: 14
    });
});


;// CONCATENATED MODULE: ./src/screens/home/landing/newsSection/newsSection.tsx







var CONTENT = [
    {
        title: "MUCHO GUSTO ・ MEGA",
        description: "Medicamentos a bajo costo y con entrega a domicilio: Te contamos c\xf3mo encontrarlos",
        image: "/assets/images/newLanding/Prensa/MuchoGusto.webp",
        link: "https://www.mega.cl/programas/mucho-gusto/mejores-momentos/154626-farmacias-baratas-medicamentos-convenientes-entrega-a-domicilio.html",
        alt: "Noticia Mucho Gusto, Mega"
    },
    {
        title: "EMOL",
        description: '"Lo pens\xf3/lo hizo" con Juan Pablo Ossa: Meki la farmacia digital que desaf\xeda a grandes cadenas prometiendo bajos precios',
        image: "/assets/images/newLanding/Prensa/Emol.webp",
        link: "https://www.emol.com/noticias/Economia/2024/08/29/1141082/juan-pablo-ossa-meki-farmacia.html",
        alt: "Noticia Emol"
    },
    {
        title: "RADIO LA CLAVE",
        description: 'Juan Pablo Ossa nos habla de su farmacia 100% online "Meki"',
        image: "/assets/images/newLanding/Prensa/RadioLaClave.webp",
        link: "https://www.youtube.com/watch?v=n3rlCGPCjEc",
        alt: "Video Radio La Clave"
    },
    {
        title: "LUN",
        description: "El paracetamol sirve para casi todo: \xbfalivia tambi\xe9n la resaca?",
        image: "/assets/images/newLanding/Prensa/LUN.webp",
        link: "https://www.lun.com/Pages/NewsDetail.aspx?dt=2024-07-23&SupplementId=0&BodyID=0&PaginaId=24&r=w",
        alt: "Noticia LUN"
    },
    {
        title: "EL MOSTRADOR",
        description: "\xbfMedicamentos de marca o bioequivalentes?",
        image: "/assets/images/newLanding/Prensa/ElMostrador.webp",
        link: "https://www.elmostrador.cl/agenda-pais/vida-en-linea/2024/09/09/medicamentos-de-marca-o-bioequivalentes/",
        alt: "Noticia El Mostrador"
    },
    {
        title: "RADIO UNIVERSO",
        description: "Farmacia Meki: La startup que revoluciona el acceso a medicamentos econ\xf3micos en Chile",
        image: "/assets/images/newLanding/Prensa/RadioUniverso.webp",
        link: "https://universo.cl/actualidad/farmacia-meki-la-startup-que-revoluciona-el-acceso-a-medicamentos-economicos-en-chile/",
        alt: "Noticia Radio Universo"
    }, 
];
function NewsSection() {
    var scrollRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showLeft = ref[0], setShowLeft = ref[1];
    var ref1 = (0,react.useState)(true), showRight = ref1[0], setShowRight = ref1[1];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var checkScrollPosition = function() {
        if (scrollRef.current) {
            var _current = scrollRef.current, scrollLeft = _current.scrollLeft, scrollWidth = _current.scrollWidth, clientWidth = _current.clientWidth;
            setShowLeft(scrollLeft > 0);
            setShowRight(scrollLeft + clientWidth < scrollWidth);
        }
    };
    var scroll = function(direction) {
        if (scrollRef.current) {
            var scrollAmount = 400;
            if (direction === "left") {
                scrollRef.current.scrollBy({
                    left: -scrollAmount,
                    behavior: "smooth"
                });
            } else {
                scrollRef.current.scrollBy({
                    left: scrollAmount,
                    behavior: "smooth"
                });
            }
        }
    };
    (0,react.useEffect)(function() {
        checkScrollPosition();
        var handleScroll = function() {
            return checkScrollPosition();
        };
        var container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsSection_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(newsSection_style_Title, {
                children: "Meki en la prensa"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(newsSection_style_ScrollContainer, {
                children: [
                    showLeft && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(newsSection_style_ScrollButton, {
                        onClick: function() {
                            return scroll("left");
                        },
                        direction: "left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsContainer, {
                        ref: scrollRef,
                        children: CONTENT.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
                                onClick: function() {
                                    window.open(item.link, "_blank", "noopener,noreferrer");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardActionArea/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                position: "relative",
                                                height: isDesktop ? 248 : 172
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: item.image,
                                                alt: item.alt,
                                                width: 400,
                                                height: isDesktop ? 248 : 172,
                                                objectFit: "cover",
                                                loading: "lazy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleCard, {
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionCard, {
                                                    children: item.description
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, item.title);
                        })
                    }),
                    showRight && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(newsSection_style_ScrollButton, {
                        onClick: function() {
                            return scroll("right");
                        },
                        direction: "right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/home/landing/storeLocatorSection/storeLocator.style.tsx



var storeLocator_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        padding: "48px 88px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12
    }, theme.breakpoints.down("sm"), {
        padding: "24px 16px",
        paddingRight: 0,
        gap: 24
    });
});
var storeLocator_style_Title = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        fontSize: "clamp(24px, 4vw, 32px)",
        fontWeight: 600,
        fontFamily: "Poppins",
        color: theme.palette.info.main,
        textAlign: "center"
    };
});
var DirectionContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        color: "#1C3D72",
        cursor: "pointer",
        marginRight: "5vw",
        marginLeft: "5vw"
    };
});
var DirectionText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: "clamp(24px, 4vw, 46px)",
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72",
        textAlign: "center",
        lineHeight: "150%"
    };
});
var ImagesContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        position: "relative",
        justifyContent: "left",
        left: 0,
        right: 0,
        flexDirection: "row",
        gap: 50,
        overflowX: "auto",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        marginTop: 16
    }, theme.breakpoints.down("md"), {
        gap: 16
    });
});
var ImageContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        flex: "0 0 auto"
    };
});


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocationOn.js
var LocationOn = __webpack_require__(69308);
;// CONCATENATED MODULE: ./src/screens/home/landing/storeLocatorSection/storeLocatorSection.tsx





var STORE_IMAGES = [
    "/assets/images/newLanding/FotosFarmacia/FotoFarmacia1.webp",
    "/assets/images/newLanding/FotosFarmacia/FotoFarmacia2.webp",
    "/assets/images/newLanding/FotosFarmacia/FotoFarmacia3.webp", 
];
var MEKI_MAP_URL = "https://maps.app.goo.gl/vE8YWQJTVisMkNVy5";
var StoreLocatorSection = function() {
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var imageSize = isDesktop ? 380 : 280;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(storeLocator_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(storeLocator_style_Title, {
                children: "\xbfD\xd3NDE ESTAMOS?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DirectionContainer, {
                onClick: function() {
                    window.open(MEKI_MAP_URL, "_blank", "noopener,noreferrer");
                },
                children: [
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {
                        sx: {
                            fontSize: 46
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionText, {
                        children: "Av. El Salto 4001・Local 8, Huechuraba, RM"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesContainer, {
                children: STORE_IMAGES.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image,
                            alt: "store",
                            width: imageSize,
                            height: imageSize
                        })
                    }, image);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/screens/home/landing/ispSection/ispSection.style.tsx


var ispSection_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        padding: "64px 0px"
    }, theme.breakpoints.down("md"), {
        padding: "56px 0px"
    });
});
var ispSection_style_ImagesContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        position: "relative",
        justifyContent: "left",
        left: 0,
        right: 0,
        flexDirection: "row",
        gap: 24,
        overflowX: "auto",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        },
        padding: "0px 84px"
    }, theme.breakpoints.down("md"), {
        gap: 16,
        padding: "0px 16px"
    });
});
var ispSection_style_ImageContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        flex: "0 0 auto",
        cursor: "pointer",
        paddingRight: 16
    };
});


;// CONCATENATED MODULE: ./src/screens/home/landing/ispSection/ispSection.tsx




var ISP_IMAGES = {
    desktop: [
        {
            image: "/assets/images/newLanding/ISP/BannerDesk2.webp",
            link: "https://www.minsal.cl/wp-content/uploads/2016/08/30-06-2016-AFICHES_GONDOLAS-DE-FARMACIAS_final_imprimir.pdf",
            alt: "ISP Medicamentos de venta directa"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerDesk3.webp",
            link: "https://www.minsal.cl/wp-content/uploads/2016/04/AFICHES-APAISADOS-1.pdf",
            alt: "ISP Uso Racional de Medicamentos"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerDesk1.webp",
            link: "https://d1zphfo9y2yvu9.cloudfront.net/docs/Resolucion+venta+online.pdf",
            alt: "ISP Resoluci\xf3n de Venta Online"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerDesk4.webp",
            link: "https://cituc.uc.cl/",
            alt: "Informaci\xf3n Toxicol\xf3gica"
        }, 
    ],
    mobile: [
        {
            image: "/assets/images/newLanding/ISP/BannerMob2.webp",
            link: "https://www.minsal.cl/wp-content/uploads/2016/08/30-06-2016-AFICHES_GONDOLAS-DE-FARMACIAS_final_imprimir.pdf",
            alt: "ISP Medicamentos de venta directa"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerMob3.webp",
            link: "https://www.minsal.cl/wp-content/uploads/2016/04/AFICHES-APAISADOS-1.pdf",
            alt: "ISP Uso Racional de Medicamentos"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerMob1.webp",
            link: "https://d1zphfo9y2yvu9.cloudfront.net/docs/Resolucion+venta+online.pdf",
            alt: "ISP Resoluci\xf3n de Venta Online"
        },
        {
            image: "/assets/images/newLanding/ISP/BannerMob4.webp",
            link: "https://cituc.uc.cl/",
            alt: "Informaci\xf3n Toxicol\xf3gica"
        }, 
    ]
};
var IspSection = function() {
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var images = isDesktop ? ISP_IMAGES.desktop : ISP_IMAGES.mobile;
    var imageWidth = isDesktop ? 550 : 274;
    var imageHeight = isDesktop ? 172 : 258;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ispSection_style_RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ispSection_style_ImagesContainer, {
            children: images.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ispSection_style_ImageContainer, {
                    onClick: function() {
                        window.open(image.link, "_blank", "noopener,noreferrer");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.image,
                        alt: image.alt || "ISP banner",
                        width: imageWidth,
                        height: imageHeight
                    })
                }, image.image);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./src/hooks/useFacebookPixel.ts
var useFacebookPixel = __webpack_require__(14931);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/queries/referenceCoupon/queries/validateReferenceCoupon.ts
var validateReferenceCoupon = __webpack_require__(94626);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WorkspacePremium.js
var WorkspacePremium = __webpack_require__(17437);
;// CONCATENATED MODULE: ./src/screens/home/landing/priceComparator/pacsCard.style.tsx


function pacsCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  font-size: 14px;\n"
    ]);
    pacsCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PACCardContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#FFFFFF",
        padding: 8,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 8,
        flex: "0 0 auto",
        cursor: "default",
        border: "1px solid #E5E5F5"
    }, theme.breakpoints.down("md"), {
        flexDirection: "column"
    });
});
var pacsCard_style_TitleCard = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme, title = param.title, subtitle = param.subtitle;
    var _obj;
    return _obj = {
        position: "relative",
        "&::before": {
            content: '"'.concat(title, '"'),
            display: "block"
        },
        "&::after": {
            content: '"'.concat(subtitle, '"'),
            display: "block"
        },
        background: "#E5E5F566"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        height: 240,
        width: 156
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        height: 90,
        width: 254
    }), (0,_define_property/* default */.Z)(_obj, "borderRadius", 10), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "alignItems", "center"), (0,_define_property/* default */.Z)(_obj, "justifyContent", "center"), (0,_define_property/* default */.Z)(_obj, "display", "flex"), (0,_define_property/* default */.Z)(_obj, "fontSize", 16), (0,_define_property/* default */.Z)(_obj, "fontWeight", 600), (0,_define_property/* default */.Z)(_obj, "fontFamily", "Poppins"), (0,_define_property/* default */.Z)(_obj, "flexDirection", "column"), _obj;
});
var ContentCard = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        height: 240,
        width: 362
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        height: 204,
        width: 254
    }), (0,_define_property/* default */.Z)(_obj, "borderRadius", 10), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "display", "flex"), (0,_define_property/* default */.Z)(_obj, "fontSize", 20), (0,_define_property/* default */.Z)(_obj, "fontWeight", 600), (0,_define_property/* default */.Z)(_obj, "fontFamily", "Poppins"), (0,_define_property/* default */.Z)(_obj, "flexDirection", "column"), (0,_define_property/* default */.Z)(_obj, "border", "1px solid #E5E5F5"), (0,_define_property/* default */.Z)(_obj, "position", "relative"), _obj;
});
var CategoriesCardContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "relative",
        display: "flex",
        flexDirection: "row",
        gap: 30,
        overflowX: "auto",
        padding: "64px",
        paddingBottom: 10,
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none"
        }
    }, theme.breakpoints.down("md"), {
        gap: 16,
        padding: "4px 16px"
    });
});
var RowComparator = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, firstRanked = param.firstRanked, bold = param.bold, lastRow = param.lastRow;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        padding: "0 16px",
        minHeight: "46px",
        borderTop: "1px solid #eaeaea",
        backgroundColor: firstRanked ? "#E5E5F5" : "white",
        color: firstRanked ? "#5d5fef" : "black",
        fontWeight: bold ? "600" : "",
        width: "100%",
        borderRadius: firstRanked ? "10px 10px 0px 0px" : lastRow ? "0px 0px 10px 10px" : "0px"
    }, theme.breakpoints.down("md"), {
        fontSize: 12,
        minHeight: "40px"
    });
});
var TitleComparatorRow = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, firstRanked = param.firstRanked;
    return (0,_define_property/* default */.Z)({
        display: "flex",
        alignItems: "center",
        gap: !firstRanked ? 6 : 0
    }, theme.breakpoints.down("md"), {
        gap: !firstRanked ? 8 : 0
    });
});
var RankingComparatorColumn = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        flexGrow: 1,
        textAlign: "right",
        fontSize: 14
    }, theme.breakpoints.down("md"), {
        fontSize: 12
    });
});
var ProviderNameDiv = (0,styled/* default */.Z)("div")(pacsCard_style_templateObject());
var PriceColumn = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end"
    };
});
var PriceTextContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    };
});
var SalePriceText = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontSize: 12,
        fontWeight: 400,
        textDecoration: "line-through",
        color: "#757475"
    };
});
var PriceText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var bold = param.bold, discountColor = param.discountColor, firstRanked = param.firstRanked, isText = param.isText;
    return {
        fontWeight: bold ? "600" : "400",
        color: discountColor || firstRanked ? "#5D5FEF" : isText ? "#757475" : "black",
        flexGrow: isText ? 1 : 0,
        textAlign: isText ? "right" : "center",
        fontSize: isText ? 12 : 14,
        paddingRight: isText ? 16 : 0
    };
});
var BottomContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        padding: "12px",
        borderTop: "1px solid #eaeaea",
        display: "flex",
        flexDirection: "row",
        position: "relative",
        bottom: 0,
        left: 0,
        right: 0,
        minHeight: "30px"
    };
});
var BottomTextNoInfo = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        textAlign: "left",
        fontSize: 12,
        color: "#979797"
    }, theme.breakpoints.down("md"), {
        fontSize: 10
    });
});
var pacsCard_style_ScrollContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
        justifyContent: "center"
    };
});
var pacsCard_style_ScrollButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function(param) {
    var direction = param.direction;
    return {
        backgroundColor: "#5d5fef",
        color: "#FFFFFF",
        position: "absolute",
        zIndex: 2,
        "&:hover": {
            backgroundColor: "#8284ee"
        },
        marginTop: 48,
        right: direction === "right" ? 100 : "auto",
        left: direction === "left" ? 100 : "auto"
    };
});


;// CONCATENATED MODULE: ./src/screens/home/landing/priceComparator/pacsCard.tsx







var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J();
function PACsCard(param) {
    var contentPacs = param.contentPacs;
    var scrollRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showLeft = ref[0], setShowLeft = ref[1];
    var ref1 = (0,react.useState)(true), showRight = ref1[0], setShowRight = ref1[1];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var checkScrollPosition = function() {
        if (scrollRef.current) {
            var _current = scrollRef.current, scrollLeft = _current.scrollLeft, scrollWidth = _current.scrollWidth, clientWidth = _current.clientWidth;
            setShowLeft(scrollLeft > 0);
            setShowRight(scrollLeft + clientWidth < scrollWidth);
        }
    };
    var scroll = function(direction) {
        if (scrollRef.current) {
            var scrollAmount = 400;
            if (direction === "left") {
                scrollRef.current.scrollBy({
                    left: -scrollAmount,
                    behavior: "smooth"
                });
            } else {
                scrollRef.current.scrollBy({
                    left: scrollAmount,
                    behavior: "smooth"
                });
            }
        }
    };
    (0,react.useEffect)(function() {
        checkScrollPosition();
        var handleScroll = function() {
            return checkScrollPosition();
        };
        var container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(pacsCard_style_ScrollContainer, {
        children: [
            showLeft && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(pacsCard_style_ScrollButton, {
                onClick: function() {
                    return scroll("left");
                },
                direction: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesCardContainer, {
                ref: scrollRef,
                children: contentPacs.map(function(pacs) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PACCardContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pacsCard_style_TitleCard, {
                                title: pacs.title,
                                subtitle: pacs.subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentCard, {
                                children: [
                                    pacs.pharmacies.map(function(pharmacy, index) {
                                        var firstRanked = pharmacy.ranking == 1 && Boolean(pharmacy.finalPrice);
                                        var lastRow = index === pacs.pharmacies.length - 1 && !Boolean(pacs.notFoundPrices.length);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowComparator, {
                                            bold: true,
                                            firstRanked: firstRanked,
                                            lastRow: lastRow,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleComparatorRow, {
                                                    firstRanked: firstRanked,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingComparatorColumn, {
                                                            children: firstRanked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkspacePremium/* default */.Z, {
                                                                fontSize: "small",
                                                                style: {
                                                                    position: "relative",
                                                                    right: 6
                                                                }
                                                            }) : "".concat(pharmacy.ranking, ".")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderNameDiv, {
                                                            children: pharmacy.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                    isText: true,
                                                    discountColor: pharmacy.name === "Meki" && pharmacy.salePrice > 0,
                                                    firstRanked: firstRanked,
                                                    children: "desde:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceColumn, {
                                                    children: [
                                                        pharmacy.salePrice && pharmacy.salePrice < pharmacy.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(SalePriceText, {
                                                            children: currencyFormatter.format(pharmacy.price)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTextContainer, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                                bold: pharmacy.name === "Meki",
                                                                discountColor: pharmacy.name === "Meki" && pharmacy.salePrice > 0,
                                                                firstRanked: firstRanked,
                                                                children: pharmacy.price || pharmacy.salePrice ? currencyFormatter.format(pharmacy.salePrice && pharmacy.salePrice < pharmacy.price ? pharmacy.salePrice : pharmacy.price) : "No lo encontramos"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, pharmacy.name);
                                    }),
                                    Boolean(pacs.notFoundPrices.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BottomTextNoInfo, {
                                            children: [
                                                "No se encontraron precios en:",
                                                " ",
                                                pacs.notFoundPrices.join(", ")
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }, pacs.title);
                })
            }),
            showRight && isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(pacsCard_style_ScrollButton, {
                onClick: function() {
                    return scroll("right");
                },
                direction: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/home/landing/priceComparator/priceComparator.store.ts
var priceComparator_store = __webpack_require__(69185);
;// CONCATENATED MODULE: ./src/screens/home/landing/priceComparator/priceComparator.style.tsx



var priceComparator_style_RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        background: "white",
        display: "flex",
        flexDirection: "column",
        gap: 8,
        padding: "68px 0px"
    }, theme.breakpoints.down("md"), {
        padding: "32px 0px"
    });
});
var PriceComparatorTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontSize: 56,
        fontWeight: 500,
        fontFamily: "Poppins",
        color: "#1C3D72"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        fontSize: 24
    }), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "lineHeight", "36px"), _obj;
});
var PriceComparatorTitleContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: 16,
        flexWrap: "wrap",
        padding: "0px 16px"
    };
});
var PriceComparatorSubtitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontSize: 32,
        fontWeight: 600,
        color: theme.palette.info.main
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        fontSize: 20,
        paddingTop: "0"
    }), (0,_define_property/* default */.Z)(_obj, "paddingTop", "32px"), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "lineHeight", "36px"), (0,_define_property/* default */.Z)(_obj, "paddingRight", 32), (0,_define_property/* default */.Z)(_obj, "paddingLeft", 32), _obj;
});
var UpdatePriceText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontSize: 12,
        fontWeight: 400,
        color: "#15365F",
        textAlign: "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        fontSize: 14
    }), (0,_define_property/* default */.Z)(_obj, "padding", "0px 32px"), _obj;
});
var priceComparator_style_SearchMedicineButton = (0,styled/* default */.Z)(Button/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#0A7ABE",
        color: "white",
        padding: "8px 24px",
        fontSize: 16,
        fontWeight: 500,
        fontFamily: "Poppins",
        borderRadius: 100,
        position: "relative",
        "&:hover": {
            backgroundColor: "#0A7ABE"
        },
        height: 58,
        textTransform: "none",
        alignSelf: "center",
        marginTop: 64
    }, theme.breakpoints.down("md"), {
        height: 42,
        marginTop: 32
    });
});


;// CONCATENATED MODULE: ./src/screens/home/landing/priceComparator/priceComparator.tsx





function PriceComparator() {
    var focusSearchBox = (0,useFocusSearchBox/* useFocusSearchBox */.G)();
    var ref = (0,priceComparator_store/* usePriceComparatorStore */.s)(), contentPacs = ref.contentPacs, uploadDate = ref.uploadDate, uploadTime = ref.uploadTime;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(priceComparator_style_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComparatorTitleContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceComparatorTitle, {
                    children: [
                        "Precios ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "m\xe1s bajos"
                        }),
                        " en miles"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComparatorSubtitle, {
                children: "DE MEDICAMENTOS \uD83C\uDF89 "
            }),
            ((ref1 = contentPacs === null || contentPacs === void 0 ? void 0 : contentPacs.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PACsCard, {
                        contentPacs: contentPacs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePriceText, {
                        children: "Precios de portales web, actualizado el ".concat(uploadDate, " a las ").concat(uploadTime, " hrs.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(priceComparator_style_SearchMedicineButton, {
                onClick: function() {
                    focusSearchBox.onfocus();
                },
                children: "Buscar mis medicamentos"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
// EXTERNAL MODULE: ./src/hooks/useScrollTracking.tsx
var useScrollTracking = __webpack_require__(96657);
// EXTERNAL MODULE: ./src/screens/home/landing/chatwoot.ts
var chatwoot = __webpack_require__(19220);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
;// CONCATENATED MODULE: ./src/screens/home/landing/index.tsx






























function Landing() {
    var searchRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(true), isVisible = ref[0], setIsVisible = ref[1];
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var trackScroll = (0,useScrollTracking/* useScrollTracking */.l)().trackScroll;
    trackScroll(Screen/* ScreenEventType.ScreenHomeView */.O.ScreenHomeView);
    var router = (0,next_router.useRouter)();
    var _query = router.query, code = _query.codigo;
    var setReferralCode = (0,useMekiState/* useMekiState */.c)().setReferralCode;
    var trackFBEvent = (0,useFacebookPixel/* useFacebokPixelEvent */.o)().trackFBEvent;
    var codeString = code ? decodeURI(code) : "";
    var ref1 = (0,useAuth/* useAuth */.a)(), user = ref1.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref2 = (0,useQuery/* useQuery */.a)((0,validateReferenceCoupon/* ValidateReferenceCouponQuerie */.j)(), {
        variables: {
            params: {
                code: codeString.replace(/\s.*/g, "")
            }
        },
        fetchPolicy: "cache-first",
        skip: !codeString.replace(/\s.*/g, "")
    }), tmp = ref2.data, ref3 = tmp === void 0 ? {} : tmp, referralUser = ref3.validateReferenceCoupon;
    var enabled = !isLocalVendor && !isAssistantUser;
    (0,chatwoot/* useChatwoot */.B)({
        enabled: enabled
    });
    (0,react.useEffect)(function sanitizeReferalCode() {
        var ref, ref1;
        if ((referralUser === null || referralUser === void 0 ? void 0 : referralUser.type) == "referral" && ((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.codigo) === null || ref1 === void 0 ? void 0 : ref1.length) > 6) {
            var ref2;
            var routerCode = ((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.codigo).replace(/\s.*/g, "");
            void router.replace({
                pathname: router.pathname,
                query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    codigo: routerCode
                }))
            }, {
                pathname: router.asPath.replace(/\?.*/, ""),
                query: (0,utils/* removeUndefineds */.ox)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    codigo: routerCode
                }))
            });
        }
    }, [
        referralUser === null || referralUser === void 0 ? void 0 : referralUser.type,
        router
    ]);
    (0,react.useEffect)(function trackLandingView() {
        track(Screen/* ScreenEventType.ScreenLandingView */.O.ScreenLandingView, {
            referral_link: code,
            logged: !!user
        });
        trackFBEvent("track", "ViewContent", {});
    }, [
        track,
        user,
        code,
        trackFBEvent
    ]);
    (0,react.useEffect)(function() {
        if (code && (referralUser === null || referralUser === void 0 ? void 0 : referralUser.isValid)) {
            setReferralCode(referralUser.code);
        }
    }, [
        code,
        setReferralCode,
        referralUser
    ]);
    (0,react.useEffect)(function() {
        var checkVisibility = function() {
            if (!searchRef.current) return;
            var rect = searchRef.current.getBoundingClientRect();
            var elementOnTop = document.elementFromPoint(rect.left + 10, rect.top);
            setIsVisible(elementOnTop === searchRef.current);
        };
        window.addEventListener("scroll", checkVisibility);
        return function() {
            return window.removeEventListener("scroll", checkVisibility);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                referralUser: referralUser
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {
                        searchRef: searchRef,
                        isVisible: isVisible,
                        setIsVisible: setIsVisible
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceComparator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareAndCheckSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CenabastSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreLocatorSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IspSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/screens/home/components/AssistantButton.tsx + 1 modules
var AssistantButton = __webpack_require__(78459);
;// CONCATENATED MODULE: ./src/screens/home/index.tsx








function LandingMain() {
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var isModalOpen = (0,useModalOpenState/* useOpenModal */.R)().isModalOpen;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (user && !isModalOpen) {
            void router.replace((0,utils/* getRoute */.Bv)("homeLoggedIn"));
        }
    }, [
        user,
        isModalOpen,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistantButton/* AssistantButton */.q, {})
        ]
    });
}


/***/ }),

/***/ 30396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ ReferralBannerDiscount; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.styles.ts
/*
 * File: referralBannerDiscount.styles.tsx
 * Project: meki
 * File Created: Wednesday, 3rd May 2023 8:43:19 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 3rd May 2023 9:33:10 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#B9D4FF",
    position: "sticky",
    bottom: 0,
    left: 0,
    width: "100%",
    minHeight: "58px",
    maxHeight: "66px",
    zIndex: 500
});
var GiftAmountTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "150%"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        fontSize: "18px"
    }), (0,_define_property/* default */.Z)(_obj, "letterSpacing", "-0.011em"), (0,_define_property/* default */.Z)(_obj, "color", "#15365F"), _obj;
});
var ValidityTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "150%"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up(700), {
        fontSize: "12px"
    }), (0,_define_property/* default */.Z)(_obj, "letterSpacing", "-0.011em"), (0,_define_property/* default */.Z)(_obj, "color", "#15365F"), _obj;
});
var CloseIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function() {
    return {
        position: "absolute",
        top: "5px",
        right: "5px"
    };
});


// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
;// CONCATENATED MODULE: ./src/screens/home/landing/ReferralBannerDiscountSection/referralBannerDiscount.tsx





function ReferralBannerDiscount(props) {
    var ref;
    var ref1 = (ref = props === null || props === void 0 ? void 0 : props.referenceCouponValidation) !== null && ref !== void 0 ? ref : {}, name = ref1.name, _lastName = ref1.lastName, lastName = _lastName === void 0 ? "" : _lastName, code = ref1.code, amount = ref1.amount, type = ref1.type, deliveryPeriods = ref1.deliveryPeriods, deliveryQuantity = ref1.deliveryQuantity;
    var setIsBannerVisible = props.setIsBannerVisible, isBannerVisible = props.isBannerVisible;
    if (!isBannerVisible) return null;
    if (type === "DELIVERY_COUPON" && deliveryPeriods === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftAmountTypography, {
                    children: [
                        "Tienes ",
                        deliveryQuantity,
                        " despacho",
                        deliveryQuantity > 1 ? "s" : "",
                        " ",
                        "gratis, sin m\xednimo de compra"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidityTypography, {
                    children: "V\xe1lido para clientes nuevos"
                })
            ]
        });
    }
    if (type === "DELIVERY_COUPON" && deliveryPeriods > 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GiftAmountTypography, {
                    children: [
                        deliveryQuantity,
                        " despacho",
                        deliveryQuantity > 1 ? "s" : "",
                        " gratis al mes, sin m\xednimo de compra"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValidityTypography, {
                    children: [
                        "V\xe1lido para clientes nuevos durante ",
                        deliveryPeriods,
                        " meses"
                    ]
                })
            ]
        });
    }
    var message = "\xa1".concat((0,utils/* capitalizeWord */.ZX)(name !== null && name !== void 0 ? name : code)).concat(lastName ? " ".concat(lastName.charAt(0).toUpperCase(), ".") : "", " te regal\xf3 ").concat(amount === null || amount === void 0 ? void 0 : amount.toLocaleString("es-CL", {
        style: "currency",
        currency: "CLP"
    }), " de descuento!");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconButton, {
                onClick: function() {
                    return setIsBannerVisible(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftAmountTypography, {
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidityTypography, {
                children: "V\xe1lido para clientes nuevos"
            })
        ]
    });
}


/***/ }),

/***/ 19220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useChatwoot; }
/* harmony export */ });
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3638);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
// src/hooks/useChatwoot.ts




var useChatwoot = function(param) {
    var enabled = param.enabled;
    var appUser = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .a)().appUser;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var generateIdentifierHash = function generateIdentifierHash(identifier, secretKey) {
            return crypto_js__WEBPACK_IMPORTED_MODULE_2___default().HmacSHA256(identifier, secretKey).toString((crypto_js__WEBPACK_IMPORTED_MODULE_2___default().enc.Hex));
        };
        var scriptId = "chatwoot-script";
        if (!enabled) {
            var existingScript = document.getElementById(scriptId);
            if (existingScript) {
                existingScript.remove();
            }
            document.querySelectorAll(".woot-widget-holder, .woot-widget-bubble").forEach(function(el) {
                return el.remove();
            });
            return;
        }
        if (document.getElementById(scriptId)) return;
        window.chatwootSettings = {
            position: "right",
            type: "standard",
            launcherTitle: "\xbfNecesitas ayuda?",
            showPopoutButton: true,
            hideMessageBubble: false,
            locale: "es",
            language: "es"
        };
        var g = document.createElement("script");
        g.id = scriptId;
        g.src = "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_BASE_URL */ .W0, "/packs/js/sdk.js");
        g.defer = true;
        g.async = true;
        document.body.appendChild(g);
        g.onload = function() {
            var ref;
            (ref = window.chatwootSDK) === null || ref === void 0 ? void 0 : ref.run({
                websiteToken: _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_WEBSITE_TOKEN */ .kq,
                baseUrl: _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_BASE_URL */ .W0
            });
            setTimeout(function() {
                if (window.$chatwoot) {
                    window.$chatwoot.setLocale("es");
                    if (appUser) {
                        var idHash = generateIdentifierHash(appUser.id.toString(), _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_SECRET */ .$K);
                        window.$chatwoot.setUser(appUser.id.toString(), {
                            email: appUser.email,
                            name: appUser.name,
                            phone_number: appUser.phone,
                            identifier_hash: idHash
                        });
                    }
                }
            }, 1000);
        };
    }, [
        enabled
    ]);
};


/***/ }),

/***/ 50633:
/***/ (function() {

/* (ignored) */

/***/ })

}]);